// removed by extract-text-webpack-plugin
module.exports = {"CardYoutubePlayer":"CardYoutubePlayer__CardYoutubePlayer___1fGWW","YoutubeFrameShadow":"CardYoutubePlayer__YoutubeFrameShadow___wK6C_","YoutubeFrame":"CardYoutubePlayer__YoutubeFrame___1DL9I","YoutubeFrameIframe":"CardYoutubePlayer__YoutubeFrameIframe___Yao8l"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/CardYoutubePlayer/CardYoutubePlayer.less
// module id = 1129
// module chunks = 0 1